"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.preview.title': 'Szczegóły Klasy Konta',
    'accountGrade.preview.back': 'Wróć do Pakietów Cenowych',
    'accountGrade.preview.edit': 'Edytuj Klasę Konta',
    'accountGrade.preview.delete': 'Usuń Klasę Konta',
    'accountGrade.preview.enabled': 'Włączone',
    'accountGrade.preview.disabled': 'Wyłączone',
    'accountGrade.preview.no_data': 'Brak dostępnych danych klasy konta',
    'accountGrade.preview.error.load_failed': 'Błąd ładowania klasy konta do podglądu',
    'accountGrade.preview.unnamed': 'Pakiet Cenowy Bez Nazwy',
    'accountGrade.preview.no_description': 'Nie podano opisu',
    'accountGrade.preview.price': 'Cena miesięczna',
    'accountGrade.preview.free': 'Darmowe',
    'accountGrade.preview.cents': 'grosze',
    'accountGrade.preview.active_status': 'Status',
    'accountGrade.preview.order': 'Kolejność Wyświetlania',
};
